import { IsNotEmpty, IsDate } from "class-validator";
import { IsAvailabilityShiftRequired } from "./validators";
import { IsStartDateBeforeEndDate } from "../common";

export class AdapterAvailabilityUpdateDto {
  @IsAvailabilityShiftRequired()
  shift_id?: string | null;

  @IsNotEmpty()
  available_hours: number;

  @IsNotEmpty()
  @IsDate()
  @IsStartDateBeforeEndDate({ context: { endDateProp: "end_date" } })
  start_date: Date;

  @IsNotEmpty()
  @IsDate()
  end_date: Date;

  @IsNotEmpty()
  availability_header_id: string;
}
